import axios from 'axios';
import { User } from 'models/response';
import qs from 'query-string';
import { trackPromise } from 'react-promise-tracker';
import { LOGINSERVICE } from 'utils/constants';

/**
 * This API log an User by username and password
 * and return User data
 * @param {string} username
 * @param {string} password
 * @return {Promise<AxiosResponse<User>>}
 */
const login = (username: string, password: string) => {
  const encodedPassword = btoa(password);
  const data = {
    username: username,
    password: encodedPassword,
  };
  return trackPromise(axios.post<User>(`${LOGINSERVICE}/login`, data), 'app');
};

/**
 * This API log an User by external token
 * and return User data
 * @param {string} code
 * @param {string} accessToken
 * @return {Promise<AxiosResponse<User>>}
 */
const oAuthLogin = (code: string, accessToken: string) =>
  trackPromise(
    // eslint-disable-next-line @typescript-eslint/camelcase
    axios.post<User>(`${LOGINSERVICE}/loginOAuth`, qs.stringify({ code, access_token: accessToken })),
    'app',
  );

/**
 * This API check if an User still has a valid jwt token
 * and return User data
 * @param {string} token
 * @return {Promise<AxiosResponse<User>>}
 */
const checkLogin = () =>
  trackPromise(axios.post<User>(`${LOGINSERVICE}/checkLogin`), 'app');

/**
 * User logout
 * @return {Promise<AxiosResponse<User>>}
 */
const logout = () => axios.post(`${LOGINSERVICE}/logout`);

export default {
  login,
  checkLogin,
  logout,
  oAuthLogin,
};
